module.exports = __webpack_public_path__ + "img/dentcloud-logo-darkblue.7c7cf6b8.png";